/**
 * This object contains errors that can be thrown (e.g. throw new Error(sentryErrorsToIgnore.NO_IMAGE))
 * that are captured by an ErrorBoundary, but are NOT sent to Sentry
 */
export const sentryErrorsToIgnore = {
  NO_IMAGE: "No Image",
};
